import { z } from "zod";
import { artifactLinkInputSchema, attachArtifactResponseSchema, detachArtifactResponseSchema } from "../artifact-links.js";
import { defineOperation } from "./http.js";
const request = { params: z.object({ artifactId: z.string().min(1) }).strict(), body: artifactLinkInputSchema };
const openapi = {
    description: "Placement preserves original artifact access rules and identity. Detach removes only the explicit reference, including a stale reference after source access was revoked.",
    responseDescription: "Reference changed, or an idempotent no-op", errors: [400, 401, 403, 404],
};
export const TWIN_ARTIFACT_LINK_OPERATIONS = {
    attachArtifact: defineOperation({
        operationId: "twin.artifacts.attach", method: "POST", path: "/api/twin/artifacts/{artifactId}/links",
        audience: "public", requiredScope: "twin.write", rateClass: "create", request,
        response: { kind: "json", status: 200, schema: attachArtifactResponseSchema },
        sdk: { namespace: "twin", method: "attachTwinArtifact" }, mcpTool: "twin_artifact_attach",
        openapi: { ...openapi, summary: "Attach an existing artifact reference" },
    }),
    detachArtifact: defineOperation({
        operationId: "twin.artifacts.detach", method: "DELETE", path: "/api/twin/artifacts/{artifactId}/links",
        audience: "public", requiredScope: "twin.write", rateClass: "create", request,
        response: { kind: "json", status: 200, schema: detachArtifactResponseSchema },
        sdk: { namespace: "twin", method: "detachTwinArtifact" }, mcpTool: "twin_artifact_detach",
        openapi: { ...openapi, summary: "Detach an existing artifact reference" },
    }),
};
